import { moduleColorClass } from '../../../utils/moduleColors';

export interface ModuleDotProps {
  /** Índice do módulo (define a cor cíclica). `-1` para "sem módulo". */
  readonly index: number;
  /** Variante de forma: `dot` (círculo) ou `square` (quadradinho arredondado). */
  readonly shape?: 'dot' | 'square';
}

/**
 * Marcador colorido de módulo (bolinha/quadradinho), com cor de token derivada do índice.
 */
export function ModuleDot({ index, shape = 'square' }: ModuleDotProps) {
  return (
    <span
      aria-hidden="true"
      className={[
        'inline-block size-[0.5rem] shrink-0',
        shape === 'dot' ? 'rounded-circular' : 'rounded-[0.1875rem]',
        moduleColorClass(index),
      ].join(' ')}
    />
  );
}
